// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 8: DIE HILFE DES HÖCHSTEN (BONUS)
// ============================================================================
// Stufe 92 (1 Bonusstufe, 3 Fragen)

export const chapter8Translations = {
  name: "Die Hilfe des Höchsten",
  description: "Wer unter dem Schirm des Höchsten sitzt, der bleibt unter dem Schatten des Allmächtigen",
  
  spiritualWisdom: {
    principle: "Du bist auf dem Gipfel des Berges angekommen, und das Wissen ist erworben",
    scripture: "Wer unter dem Schirm des Höchsten sitzt, der bleibt unter dem Schatten des Allmächtigen (Psalm 91:1)",
    application: "Unerschütterlicher Glaube erfordert Lebenserfahrung, Barmherzigkeit und die wahre Liebe Jesu. Die Prüfungen werden dein Herz testen, den wahren gewählten Weg."
  },
  
  levels: {
    92: {
      name: "Der Schirm des Höchsten",
      challenge: "Du bist auf dem Gipfel des Berges... Aber der unerschütterliche Glaube beginnt jetzt...",
      easy: {
        question: "Wer ist Jesus für dich persönlich?",
        options: [
          "Ein einfacher Prophet",
          "Mein persönlicher Herr und Retter",
          "Eine Legende",
          "Ein Philosoph"
        ],
        hint: "Er ist derjenige, der sein Leben gibt, um uns zu retten",
        funFact: "✝️ Jesus ist Gott! Er ist nicht nur eine historische Figur - Er lebt und wünscht sich eine persönliche Beziehung mit jedem von uns!"
      },
      medium: {
        question: "Warum ermöglicht uns das Fasten wie Daniel, Gott besser zu hören?",
        options: [
          "Um Gewicht zu verlieren",
          "Um uns dessen zu berauben, was wir lieben und ein verwandeltes Herz zu haben",
          "Um andere zu beeindrucken",
          "Um stärker zu sein"
        ],
        hint: "Verzichte auf das, was du am meisten liebst, in Ruhe und Weisheit",
        funFact: "🙏 Das geistliche Fasten bereitet unser Herz auf tiefe Verwandlungen vor - oft schmerzhaft - die uns Gott näher bringen!"
      },
      hard: {
        question: "Was ist die wahre Antwort des Herzens angesichts all dieses erworbenen Wissens?",
        options: [
          "Ich bin jetzt perfekt",
          "Ich gebe dir mein Herz Jesus und möchte getauft werden",
          "Ich weiß es besser als andere",
          "Ich brauche keine Hilfe mehr"
        ],
        hint: "Der wahre Glaube führt zur völligen Hingabe und zum Engagement mit Jesus",
        funFact: "🌟✨ Du bist auf dem Gipfel des Berges angekommen, und das Wissen ist erworben ✨\n\n💖 Unerschütterlicher Glaube erfordert Lebenserfahrung, Barmherzigkeit und die wahre Liebe Jesu 💖\n\n🔥 Die verschiedenen Prüfungen des Lebens werden deinen Weg testen, den wahren Pfad, den wir wählen, unser Herz 🔥\n\n😔 Wir bleiben unvollkommen, unsere Begierden sind zahlreich, und die Liebe zum Gewinn oder zu unserem persönlichen Komfort wird allzu oft unsere egoistische Priorität 😔\n\n🙏 Bitte Gott um Weisheit, seine Liebe, seine Kraft, und erkenne demütig deine Schwächen, denn wir können Ihm nichts verbergen... Nichts 🙏\n\n🥖 Faste wie Daniel: Verzichte für einen Moment auf das, was du am meisten liebst, in Ruhe und Weisheit 🥖\n\n💫 Das wird dir ermöglichen, Gott besser zu hören, eine Herzenshaltung zu haben, die für tiefe Verwandlungen bereit ist 💫\n\n🌙 Dann werden die Träume und Visionen klarer werden, wie bei Josef 🌙\n\n⚠️ Hüte dich vor Stolz: Gib nicht nach bei 'Ich habe immer recht' oder 'Ich weiß es besser' ⚠️\n\n🎁 Denn die Offenbarung Gottes ist eine außergewöhnliche Gnade 🎁\n\n💝 Glauben zu haben bedeutet, in eine Beziehung und einen freien Weg des Herzens einzutreten 💝\n\n🦸‍♂️ Es wird dich zu mächtigen Helden machen, fähig zum Unmöglichen 🦸‍♂️\n\n✝️ Auf dem Gipfel des Wissens sagt das aufrichtige Herz: 'Ich gebe dir mein Herz Jesus und möchte getauft werden' ✝️\n\n🏔️ Du bist auf dem Gipfel des Berges angekommen, halte fest, halte durch! 🏔️\n\n⬇️ Man muss hinabsteigen und diesen kostbaren Schatz tragen: die Hoffnung auf das ewige Leben ⬇️\n\n🏆✨ BRAVO! WIR SIND STOLZ AUF DICH ✨🏆\n🌟 MUT TAPFERER FRIEDENSBRINGER 🌟\n🕊️✨ GOTT SEGNE DICH ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
